import * as React from 'react';
import { TNotFoundFallback } from './NotFoundFallback.types';
import './NotFoundFallback.styled.scss';

export const NotFoundFallback: TNotFoundFallback = () => (
  <div className="not-found-fallback">
    <h1>404</h1>
    <p>Page not found</p>
  </div>
);
